module.exports = __webpack_public_path__ + "static/media/print.e628f8af.svg";